import { useEffect, useState } from "react";

/**
 * useScanPrefill -- liefert Prefill-Daten aus sessionStorage, die
 * vorher von ScanPage via `pw:scan-prefill` gesetzt wurden.
 * Verbraucht den Wert beim Lesen (one-shot).
 */
export function useScanPrefill() {
    const [prefill, setPrefill] = useState(null);
    useEffect(() => {
        try {
            const raw = sessionStorage.getItem("pw:scan-prefill");
            if (raw) {
                sessionStorage.removeItem("pw:scan-prefill");
                setPrefill(JSON.parse(raw));
            }
        } catch (_e) { /* ignore */ }
    }, []);
    return prefill;
}
